import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { StructuredRecordEditorCareMapDrawer } from '../structured-records/StructuredRecordEditorCareMapDrawer';
import { MedicationDescriptor } from './MedicationDescriptor';
import { MedicationFormState } from './MedicationFormState';

export type IMedicationEditorDrawerProps = {
    id: string;
};

export const MedicationEditorCareMapDrawer: FC<IMedicationEditorDrawerProps> = ({ id }) => {
    const descriptor = useInstance(MedicationDescriptor);
    const formState = useInstance(MedicationFormState);

    return (
        <StructuredRecordEditorCareMapDrawer
            descriptor={descriptor}
            formState={formState}
            id={id}
        />
    );
};
